import { useMemo } from 'react';
import { Popover as ChakraPopover, PopoverProps as ChakraPopoverProps } from '@chakra-ui/react';
import { PopoverContext, PopoverContextType } from './Popover.context';

export interface PopoverProps extends ChakraPopoverProps {
  withArrow?: boolean;
  variant?: 'dark' | 'light';
}

const Popover = (props: PopoverProps) => {
  const { variant = 'light', withArrow, ...rest } = props;
  const popoverProps = {
    arrowPadding: 16,
    arrowSize: 16,
    gutter: withArrow ? 16 : 8,
    variant,
    ...rest,
  };
  const ctx = useMemo<PopoverContextType>(
    () => ({
      withArrow,
    }),
    [withArrow],
  );

  return (
    <PopoverContext value={ctx}>
      <ChakraPopover {...popoverProps} />
    </PopoverContext>
  );
};

export default Popover;
